import {NgModule} from '@angular/core';
import {PspdfkitComponent} from './pspdfkit.component';

@NgModule({
  declarations: [
    PspdfkitComponent
  ],
  exports: [
    PspdfkitComponent,
  ]
})
export class PspdfkitModule {
}
